import React from "react";
import InputField from "../../../../../../components/elements/InputField";

export default function LinkBlockEditor({ value, onChange }) {
    const block = value || {};
    const config = block.config || {};

    const setField = (field, v) => {
        onChange({
            ...block,
            config: {
                ...config,
                [field]: v
            }
        });
    };

    return (
        <div style={{ display: "grid", gap: 8 }}>
            <label style={{ display: "grid", gap: 4 }}>
                <div style={{ fontSize: 12, opacity: 0.8 }}>Label</div>
                <InputField
                    value={config.label || ""}
                    onChange={(e) => setField("label", e.target.value)}
                    title="e.g. MDN docs"
                />
            </label>

            <label style={{ display: "grid", gap: 4 }}>
                <div style={{ fontSize: 12, opacity: 0.8 }}>URL</div>
                <InputField
                    value={config.url || ""}
                    onChange={(e) => setField("url", e.target.value)}
                    title="https://..."
                />
            </label>
        </div>
    );
}
